if (typeof window.modalChangeType === "undefined") {
  window.modalMini = {
    toggleModal: ($el, value) => {
      const $body = $("body");
      const $modal = $el.hasClass("modal-mini")
        ? $el
        : $el.closest(".modal-mini");

      if (value) {
        $modal.fadeIn("fast");
        $body.addClass("modal-mini-active");
      } else {
        $modal.fadeOut("fast");
        $body.removeClass("modal-mini-active");
      }
    },
    validateRequiredScripts: async (timeout = 2000) => {
      const start = Date.now();

      while (true) {
        const hasJQuery = typeof window.jQuery === "function";

        if (hasJQuery) {
          break;
        }

        if (Date.now() - start >= timeout) {
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 50)); // wait 50ms before rechecking
      }
    },
    init: async () => {
      await window.modalMini.validateRequiredScripts();

			// Hook
			$(".modal-mini").on("click", "[data-close-modal]", function (e) {
        e.preventDefault();
        window.modalMini.toggleModal($(this), false);
			});

			$(document).on("click", "[data-toggle='modal-mini']", function (e) {
        e.preventDefault();

        const $el = $(this);
        const $target = $($el.data('target'));
        const isDisabled = $el.attr('disabled');

        console.log('click', $target, isDisabled);

        if (!isDisabled) {
          window.modalMini.toggleModal($target, true);
        }
			});

      // Hook for Escape key
      $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
          // Do nothing if Fancybox is active
          if ($("html").hasClass("with-fancybox")) {
            return;
          }
          
          const $openModal = $(".modal-mini:visible");
          if ($openModal.length) {
            window.modalMini.toggleModal($openModal, false);
          }
        }
      });
    },
  };

  (function () {
    if (document.readyState === 'loading') {
      // DOM is still loading, wait for it
      document.addEventListener('DOMContentLoaded', function () {
        window.modalMini.init();
      });
    } else {
      // DOM is already loaded, run immediately
      window.modalMini.init();
    }
  })();
}
